export enum MyAccountDisplayMode {
  AUTH_SCREEN = 'authScreen',
  LOGIN_BUTTON = 'loginButton',
}
